<template>
  <div class="wrapper">
    <div
      v-if="header"
      class="header flex justify-between"
      :class="{ 'justify-between': header, 'justify-end': !header }"
    >
      <h2 class="flex-grow-1">
        {{ header }}
      </h2>
      <slot name="header-append" />
    </div>
    <div class="table">
      <slot name="table" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListSettingsWrapper',

  props: {
    header: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  background-color: #fff;
  order: 3;

  .header {
    padding: 0 1rem 1rem;
    align-items: center;
    border-bottom: 1px solid $gray-100;

    @media screen and (min-width: $lg) {
      display: none;

      + .table {
        padding: 1rem 0;
      }
    }
  }

  .table {
    width: 100%;
    padding: 0;
    position: relative;
  }
}
</style>
